import PropTypes from 'prop-types'
import PhotoPendingImg from 'assets/img/product/photo_pending.png'
import {
  UncontrolledCarousel
} from 'reactstrap'

const defaultProps = {
  images: [  {
    s3_url  : PhotoPendingImg,
    altText : '',
    caption : '',
    key     : 1
  },
  {
    s3_url  : PhotoPendingImg,
    altText : '',
    caption : '',
    key     : 2
  },
  {
    s3_url  : PhotoPendingImg,
    altText : '',
    caption : '',
    key     : 3
  } ],
  altText: ''
}

const propTypes = {
  images  : PropTypes.arrayOf(PropTypes.object).isRequired,
  altText : PropTypes.string
}

const ProductImageCarousel = ({
  images,
  altText
}) => {
  let items = []
  images.map((image) => {
    const imageObj = {
      src     : image.s3_url || PhotoPendingImg,
      altText : altText,
      caption : '',
      key     : image.id
    }
    items.push(imageObj)
  })

  return (
    <UncontrolledCarousel
      items={ items }
      autoPlay={ false }
    />
  )
}

ProductImageCarousel.propTypes    = propTypes
ProductImageCarousel.defaultProps = defaultProps

export default ProductImageCarousel
